export default "__VITE_ASSET__BcmQ3T6a__"